import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import './calendario.css';

dayjs.locale('es');

/**
 * Calendario component
 * Props:
 * - validDates: array of strings 'YYYY-MM-DD' for selectable dates
 * - onDateSelect: callback(dayjsDate) when a valid date is clicked
 * - displayDate: optional string or Date/Dayjs to control the displayed month
 */
const Calendario = ({ validDates = [], onDateSelect, displayDate = null }) => {
  const [currentDate, setCurrentDate] = useState(
    displayDate ? dayjs(displayDate) : dayjs()
  );

  useEffect(() => {
    if (displayDate) {
      setCurrentDate(dayjs(displayDate));
    }
  }, [displayDate]);

  const startOfMonth = currentDate.startOf('month');
  const endOfMonth = currentDate.endOf('month');
  const daysInMonth = endOfMonth.date();

  const weekdayOfFirst = startOfMonth.day(); // 0=Dom, 1=Lun, ..., 6=Sab
  const offsetStart = (weekdayOfFirst + 6) % 7; // Reordenar para que Lunes=0

  const totalDays = offsetStart + daysInMonth;
  const totalSlots = Math.ceil(totalDays / 7) * 7;

  const daysInCalendar = Array.from({ length: totalSlots }, (_, i) => {
    const dayOffset = i - offsetStart;
    return dayOffset >= 0 && dayOffset < daysInMonth
      ? startOfMonth.add(dayOffset, 'day')
      : null; // Día fuera del mes
  });

  const goToNextMonth = () => setCurrentDate(currentDate.add(1, 'month'));
  const goToPrevMonth = () => setCurrentDate(currentDate.subtract(1, 'month'));

  const isDateValid = date =>
    date && validDates.includes(date.format('YYYY-MM-DD'));

  return (
    <div className="calendario">
      <div className="calendario-header">
        <button onClick={goToPrevMonth} className="calendario-btn">←</button>
        <span className="calendario-title">
          {currentDate.format('MMMM YYYY')}
        </span>
        <button onClick={goToNextMonth} className="calendario-btn">→</button>
      </div>

      <table className="calendario-tabla">
        <thead>
          <tr>
            {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map(d => (
              <th key={d} className="calendario-dia">{d}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: totalSlots / 7 }, (_, week) => (
            <tr key={week}>
              {daysInCalendar
                .slice(week * 7, week * 7 + 7)
                .map((day, idx) => (
                  <td
                    key={idx}
                    onClick={() => day && isDateValid(day) && onDateSelect(day)}
                    className={[
                      'calendario-celda',
                      day
                        ? isDateValid(day) ? 'valida' : 'invalida'
                        : 'fuera-mes'
                    ].join(' ')}
                  >
                    <b>{day ? day.date() : '-'}</b>
                  </td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Calendario;
